import { p as process$1 } from "./index-64135f7d.mjs";
import { a as initI18n, d as doInitI18n } from "./i18n-35335a5c.mjs";
import { i as i18n, s as setupDevtoolsPlugin } from "./_i18n-e414d464.mjs";
import { u as uiHelpers } from "./_ui-71f9b37c.mjs";
import { M as MalarkeyTwilioAdapter, i as isApiResponse, a as isValidConversationFeedback, b as isValidIdentityFeedback } from "./malarkeyTwilioAdapter-1c296255.mjs";
import { MalarkeyEventSocketAdapter } from "./event-socket/malarkeyEventSocketAdapter.es.js";
import { defineAsyncComponent, ref, watch } from "vue";
import { d as debug } from "./_debug-8b5c3032.mjs";
import { p as patchApiToIncludeTotp } from "./_patches-94e7586e.mjs";
function doApplicationMount(_options, originalCb, rootContainer, isHydrate, namespace) {
  let installedi18n = false;
  if ("object" !== typeof this.__VUE_I18N__) {
    this.use(i18n);
    installedi18n = true;
  }
  if (!this.config.globalProperties.$twilio) {
    this.use(MalarkeyTwilioAdapter, { ssr: _options.ssr });
  }
  if (!this.config.globalProperties.$eventSocket) {
    this.use(MalarkeyEventSocketAdapter, { ssr: _options.ssr });
  }
  if (this.malarkey) {
    return originalCb.call(this, rootContainer, isHydrate, namespace);
  }
  this.malarkey = true;
  debug("Mounting Component: 'Malarkey'");
  this.component(
    "Malarkey",
    defineAsyncComponent(() => import("./components/Malarkey.es.js"))
  );
  debug("Mounting Component: 'MalarkeyChat'");
  this.component(
    "MalarkeyChat",
    defineAsyncComponent(() => import("./components/MalarkeyChat.es.js"))
  );
  debug("Mounting Component: 'MalarkeyContactRoster'");
  this.component(
    "MalarkeyContactRoster",
    defineAsyncComponent(
      () => import("./components/MalarkeyContactRoster.es.js")
    )
  );
  debug("Mounting Component: 'MalarkeyContactSearch'");
  this.component(
    "MalarkeyContactSearch",
    defineAsyncComponent(
      () => import("./components/MalarkeyContactSearch.es.js")
    )
  );
  debug("Mounting Component: 'MalarkeyConversationList'");
  this.component(
    "MalarkeyConversationList",
    defineAsyncComponent(
      () => import("./components/MalarkeyConversationList.es.js")
    )
  );
  debug("Mounting Component: 'MalarkeyI18nPicker'");
  this.component(
    "MalarkeyI18nPicker",
    defineAsyncComponent(() => import("./components/MalarkeyI18nPicker.es.js"))
  );
  debug("Mounting Component: 'MalarkeyLogin'");
  this.component(
    "MalarkeyLogin",
    defineAsyncComponent(() => import("./components/MalarkeyLogin.es.js"))
  );
  debug("Mounting Component: 'MalarkeyStartChat'");
  this.component(
    "MalarkeyStartChat",
    defineAsyncComponent(() => import("./components/MalarkeyStartChat.es.js"))
  );
  debug("Mounting Component: 'MalarkeyToolbarUserMenu'");
  this.component(
    "MalarkeyToolbarUserMenu",
    defineAsyncComponent(
      () => import("./components/MalarkeyToolbarUserMenu.es.js")
    )
  );
  debug("Mounting Component: 'MPasswordField'");
  this.component(
    "MPasswordField",
    defineAsyncComponent(
      () => import("./components/constituants/MPasswordField.es.js")
    )
  );
  debug("Mounting Component: 'MalarkeyAttachmentPane'");
  this.component(
    "MalarkeyAttachmentPane",
    defineAsyncComponent(
      () => import("./components/constituants/MalarkeyAttachmentPane.es.js")
    )
  );
  debug("Mounting Component: 'MalarkeyChatInputForm'");
  this.component(
    "MalarkeyChatInputForm",
    defineAsyncComponent(
      () => import("./components/constituants/MalarkeyChatInputForm.es.js")
    )
  );
  debug("Mounting Component: 'MalarkeyChatMessagePane'");
  this.component(
    "MalarkeyChatMessagePane",
    defineAsyncComponent(
      () => import("./components/constituants/MalarkeyChatMessagePane.es.js")
    )
  );
  debug("Mounting Component: 'MalarkeyChatMessagePaneItem'");
  this.component(
    "MalarkeyChatMessagePaneItem",
    defineAsyncComponent(
      () => import("./components/constituants/MalarkeyChatMessagePaneItem.es.js")
    )
  );
  debug("Mounting Component: 'MalarkeyContactAvatar'");
  this.component(
    "MalarkeyContactAvatar",
    defineAsyncComponent(
      () => import("./components/constituants/MalarkeyContactAvatar.es.js")
    )
  );
  debug("Mounting Component: 'MalarkeyContactRosterItem'");
  this.component(
    "MalarkeyContactRosterItem",
    defineAsyncComponent(
      () => import("./components/constituants/MalarkeyContactRosterItem.es.js")
    )
  );
  debug("Mounting Component: 'MalarkeyContactSearchItem'");
  this.component(
    "MalarkeyContactSearchItem",
    defineAsyncComponent(
      () => import("./components/constituants/MalarkeyContactSearchItem.es.js")
    )
  );
  debug("Mounting Component: 'MalarkeyConversationListItem'");
  this.component(
    "MalarkeyConversationListItem",
    defineAsyncComponent(
      () => import("./components/constituants/MalarkeyConversationListItem.es.js")
    )
  );
  debug("Mounting Core");
  const ret = originalCb.call(this, rootContainer, isHydrate, namespace);
  if (installedi18n) {
    initI18n(this);
  }
  doInitI18n(this);
  if (!this.config.globalProperties.$alert) {
    this.use(uiHelpers);
  }
  debug("Core Mounted");
  if (process$1.env.NODE_ENV === "development" || false) {
    setupDevtoolsPlugin(
      {
        id: "@nhtio/malarkey-client-core",
        label: "Malarkey Client Core Components",
        packageName: "@nhtio/malarkey-client-core",
        homepage: "https://vuejs-core-nht4944308-products-malarkey-aef3e28033c21d20f834fba.gitlab.io/",
        // @ts-ignore
        app: this
      },
      (api) => {
        api.on.inspectComponent((payload) => {
          var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z;
          payload.instanceData.state.push({
            type: "$bus",
            key: "$bus",
            value: {
              active: (_a = this.config.globalProperties.$bus) == null ? void 0 : _a.active.value,
              inactiveTooLong: (_b = this.config.globalProperties.$bus) == null ? void 0 : _b.inactiveTooLong.value,
              uuid: (_c = this.config.globalProperties.$bus) == null ? void 0 : _c.uuid
            }
          });
          payload.instanceData.state.push({
            type: "$cron",
            key: "$cron",
            value: {
              running: (_d = this.config.globalProperties.$cron) == null ? void 0 : _d.running
            }
          });
          payload.instanceData.state.push({
            type: "$ls",
            key: "$ls",
            value: {
              loaded: (_e = this.config.globalProperties.$ls) == null ? void 0 : _e.loaded,
              records: (_f = this.config.globalProperties.$ls) == null ? void 0 : _f.value
            }
          });
          payload.instanceData.state.push({
            type: "$identity",
            key: "$identity",
            value: {
              authenticated: (_g = this.config.globalProperties.$identity) == null ? void 0 : _g.authenticated.value,
              booted: (_h = this.config.globalProperties.$identity) == null ? void 0 : _h.booted.value,
              identified: (_i = this.config.globalProperties.$identity) == null ? void 0 : _i.identified.value,
              refreshable: (_j = this.config.globalProperties.$identity) == null ? void 0 : _j.refreshable.value,
              ttl: (_k = this.config.globalProperties.$identity) == null ? void 0 : _k.ttl.value,
              user: (_l = this.config.globalProperties.$identity) == null ? void 0 : _l.user.value
            }
          });
          payload.instanceData.state.push({
            type: "$lang",
            key: "$lang",
            value: {
              list: (_m = this.config.globalProperties.$lang) == null ? void 0 : _m.list.value,
              language: (_n = this.config.globalProperties.$lang) == null ? void 0 : _n.language.value,
              showSwitchPrompt: (_o = this.config.globalProperties.$lang) == null ? void 0 : _o.showSwitchPrompt.value
            }
          });
          payload.instanceData.state.push({
            type: "$push",
            key: "$push",
            value: {
              appUpdatePending: (_p = this.config.globalProperties.$push) == null ? void 0 : _p.appUpdatePending.value,
              booted: (_q = this.config.globalProperties.$push) == null ? void 0 : _q.booted.value,
              canPush: (_r = this.config.globalProperties.$push) == null ? void 0 : _r.canPush.value,
              canRequestPermission: (_s = this.config.globalProperties.$push) == null ? void 0 : _s.canRequestPermission.value,
              serviceWorkerState: (_t = this.config.globalProperties.$push) == null ? void 0 : _t.serviceWorkerState.value
            }
          });
          payload.instanceData.state.push({
            type: "$twilio",
            key: "$twilio",
            value: {
              initialized: (_u = this.config.globalProperties.$twilio) == null ? void 0 : _u.initialized.value,
              me: (_v = this.config.globalProperties.$twilio) == null ? void 0 : _v.me.value,
              connectionState: (_w = this.config.globalProperties.$twilio) == null ? void 0 : _w.connectionState.value,
              typing: (_x = this.config.globalProperties.$twilio) == null ? void 0 : _x.typing.value,
              roster: (_y = this.config.globalProperties.$twilio) == null ? void 0 : _y.roster.value,
              conversations: (_z = this.config.globalProperties.$twilio) == null ? void 0 : _z.conversations.value
            }
          });
        });
      }
    );
    debug("Devtools enabled");
  } else {
    debug("Devtools not enabled");
  }
  return ret;
}
function doApplicationUnmount(originalCb) {
  debug("Unmounting Core");
  const ret = originalCb.call(this);
  debug("Core Unmounted");
  return ret;
}
const getProxiedModelRef = (prop, onChange) => {
  const model = ref(prop);
  watch(
    () => prop,
    (is, _was) => {
      model.value = is;
    },
    { immediate: true }
  );
  watch(
    () => model.value,
    (value) => {
      onChange(value);
    },
    { immediate: true }
  );
  return model;
};
const _internal = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  debug,
  doApplicationMount,
  doApplicationUnmount,
  getProxiedModelRef,
  isApiResponse,
  isValidConversationFeedback,
  isValidIdentityFeedback,
  patchApiToIncludeTotp
}, Symbol.toStringTag, { value: "Module" }));
export {
  _internal as _,
  doApplicationUnmount as a,
  doApplicationMount as d,
  getProxiedModelRef as g
};
//# sourceMappingURL=_internal-8e885689.mjs.map
